/* eslint-disable consistent-return */
import { useEffect } from 'react';
import emitter from '../eventEmitter';

/**
 * Subscribes a component to an app event emitter key for as long as it is mounted.
 * Adds the listener when both key and callback are set, re-subscribing when key or deps change, and
 * on teardown runs the optional cleanup before removing the listener.
 *
 * @param key - Emitter event name to listen to.
 * @param callback - Handler invoked when the event fires.
 * @param deps - Extra dependencies that trigger a re-subscription.
 * @param cleanup - Optional function run before the listener is removed.
 * @returns The shared event emitter.
 */
export default function useEmitter(key: any, callback: any, deps: any[], cleanup?: any) {
  useEffect(() => {
    if (!(key && callback)) return;
    const listener = emitter.addListener(key, callback);
    return () => {
      cleanup?.();
      listener.remove();
    };
  }, [key, ...deps]);

  return emitter;
}
